import Vue from 'vue';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchAllSubscriber', data);
  resolve();
};

const failed = (errors, reject) => {
  reject(errors);
};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http
      .get(`subscriberList/${id}/allSubscriber`)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/subscriber/all.js